var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThunder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.13725 16.8785L11.7129 13.1483C12.056 12.7903 12.6383 13.133 12.5118 13.6184L11.7581 16.5097L14.6469 17.3053C14.9993 17.4024 15.1189 17.8543 14.8628 18.1215L11.2871 21.8517C10.944 22.2097 10.3617 21.867 10.4882 21.3816L11.2419 18.4903L8.35311 17.6947C8.00066 17.5976 7.88114 17.1457 8.13725 16.8785Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.65764 16.4427C6.74867 16.2266 6.88025 16.0221 7.05432 15.8405L10.63 12.1103C11.3386 11.3711 12.3496 11.3627 13.0491 11.7743C13.7414 12.1817 14.212 13.0421 13.9632 13.9967L13.5827 15.4564L15.0452 15.8592C15.6834 16.035 16.1266 16.4733 16.3442 17H18C20.2091 17 22 15.2091 22 13C22 10.7909 20.2091 9 18 9C17.6514 9 17.3133 9.04459 16.991 9.12836C16.7973 5.15887 13.5175 2 9.5 2C5.35786 2 2 5.35786 2 9.5C2 12.6361 3.92488 15.3227 6.65764 16.4427Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThunder);
export default __webpack_public_path__ + "static/media/thunder.f31db9e2eb89a4b9fded5748ae921655.svg";
export { ForwardRef as ReactComponent };